'use strict';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var browser = {exports: {}};

var quickFormatUnescaped;
var hasRequiredQuickFormatUnescaped;
function requireQuickFormatUnescaped() {
  if (hasRequiredQuickFormatUnescaped) return quickFormatUnescaped;
  hasRequiredQuickFormatUnescaped = 1;
  function tryStringify(o) {
    try {
      return JSON.stringify(o);
    } catch (e) {
      return '"[Circular]"';
    }
  }
  quickFormatUnescaped = format;
  function format(f, args, opts) {
    var ss = opts && opts.stringify || tryStringify;
    var offset = 1;
    if (_typeof(f) === 'object' && f !== null) {
      var len = args.length + offset;
      if (len === 1) return f;
      var objects = new Array(len);
      objects[0] = ss(f);
      for (var index = 1; index < len; index++) {
        objects[index] = ss(args[index]);
      }
      return objects.join(' ');
    }
    if (typeof f !== 'string') {
      return f;
    }
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = '';
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for (var i = 0; i < flen;) {
      if (f.charCodeAt(i) === 37 && i + 1 < flen) {
        lastPos = lastPos > -1 ? lastPos : 0;
        switch (f.charCodeAt(i + 1)) {
          case 100: // 'd'
          case 102:
            // 'f'
            if (a >= argLen) break;
            if (args[a] == null) break;
            if (lastPos < i) str += f.slice(lastPos, i);
            str += Number(args[a]);
            lastPos = i + 2;
            i++;
            break;
          case 105:
            // 'i'
            if (a >= argLen) break;
            if (args[a] == null) break;
            if (lastPos < i) str += f.slice(lastPos, i);
            str += Math.floor(Number(args[a]));
            lastPos = i + 2;
            i++;
            break;
          case 79: // 'O'
          case 111: // 'o'
          case 106:
            // 'j'
            if (a >= argLen) break;
            if (args[a] === undefined) break;
            if (lastPos < i) str += f.slice(lastPos, i);
            var type = _typeof(args[a]);
            if (type === 'string') {
              str += '\'' + args[a] + '\'';
              lastPos = i + 2;
              i++;
              break;
            }
            if (type === 'function') {
              str += args[a].name || '<anonymous>';
              lastPos = i + 2;
              i++;
              break;
            }
            str += ss(args[a]);
            lastPos = i + 2;
            i++;
            break;
          case 115:
            // 's'
            if (a >= argLen) break;
            if (lastPos < i) str += f.slice(lastPos, i);
            str += String(args[a]);
            lastPos = i + 2;
            i++;
            break;
          case 37:
            // '%'
            if (lastPos < i) str += f.slice(lastPos, i);
            str += '%';
            lastPos = i + 2;
            i++;
            a--;
            break;
        }
        ++a;
      }
      ++i;
    }
    if (lastPos === -1) return f;else if (lastPos < flen) {
      str += f.slice(lastPos);
    }
    return str;
  }
  return quickFormatUnescaped;
}

var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser.exports;
  hasRequiredBrowser = 1;
  var format = requireQuickFormatUnescaped();
  browser.exports = pino;
  var _console = pfGlobalThisOrFallback().console || {};
  var stdSerializers = {
    mapHttpRequest: mock,
    mapHttpResponse: mock,
    wrapRequestSerializer: passthrough,
    wrapResponseSerializer: passthrough,
    wrapErrorSerializer: passthrough,
    req: mock,
    res: mock,
    err: asErrValue,
    errWithCause: asErrValue
  };
  function levelToValue(level, logger) {
    return level === 'silent' ? Infinity : logger.levels.values[level];
  }
  var baseLogFunctionSymbol = Symbol('pino.logFuncs');
  var hierarchySymbol = Symbol('pino.hierarchy');
  var logFallbackMap = {
    error: 'log',
    fatal: 'error',
    warn: 'error',
    info: 'log',
    debug: 'log',
    trace: 'log'
  };
  function appendChildLogger(parentLogger, childLogger) {
    var newEntry = {
      logger: childLogger,
      parent: parentLogger[hierarchySymbol]
    };
    childLogger[hierarchySymbol] = newEntry;
  }
  function setupBaseLogFunctions(logger, levels, proto) {
    var logFunctions = {};
    levels.forEach(function (level) {
      logFunctions[level] = proto[level] ? proto[level] : _console[level] || _console[logFallbackMap[level] || 'log'] || noop;
    });
    logger[baseLogFunctionSymbol] = logFunctions;
  }
  function shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
      var hasToFilter = serialize.filter(function (k) {
        return k !== '!stdSerializers.err';
      });
      return hasToFilter;
    } else if (serialize === true) {
      return Object.keys(serializers);
    }
    return false;
  }
  function pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    var transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') {
      throw Error('pino: transmit option must have a send function');
    }
    var proto = opts.browser.write || _console;
    if (opts.browser.write) opts.browser.asObject = true;
    var serializers = opts.serializers || {};
    var serialize = shouldSerialize(opts.browser.serialize, serializers);
    var stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    var customLevels = Object.keys(opts.customLevels || {});
    var levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace'].concat(customLevels);
    if (typeof proto === 'function') {
      levels.forEach(function (level) {
        proto[level] = proto;
      });
    }
    if (opts.enabled === false || opts.browser.disabled) opts.level = 'silent';
    var level = opts.level || 'info';
    var logger = Object.create(proto);
    if (!logger.log) logger.log = noop;
    setupBaseLogFunctions(logger, levels, proto);
    // setup root hierarchy entry
    appendChildLogger({}, logger);
    Object.defineProperty(logger, 'levelVal', {
      get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
      get: getLevel,
      set: setLevel
    });
    var setOpts = {
      transmit: transmit,
      serialize: serialize,
      asObject: opts.browser.asObject,
      formatters: opts.browser.formatters,
      levels: levels,
      timestamp: getTimeFunction(opts),
      messageKey: opts.messageKey || 'msg',
      onChild: opts.onChild || noop
    };
    logger.levels = getLevels(opts);
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return child.call.apply(child, [this, setOpts].concat(args));
    };
    if (transmit) logger._logEvent = createLogEventShape();
    function getLevelVal() {
      return levelToValue(this.level, this);
    }
    function getLevel() {
      return this._level;
    }
    function setLevel(level) {
      var _this = this;
      if (level !== 'silent' && !this.levels.values[level]) {
        throw Error('unknown level ' + level);
      }
      this._level = level;
      set(this, setOpts, logger, 'error'); // <-- must stay first
      set(this, setOpts, logger, 'fatal');
      set(this, setOpts, logger, 'warn');
      set(this, setOpts, logger, 'info');
      set(this, setOpts, logger, 'debug');
      set(this, setOpts, logger, 'trace');
      customLevels.forEach(function (level) {
        set(_this, setOpts, logger, level);
      });
    }
    function child(setOpts, bindings, childOptions) {
      if (!bindings) {
        throw new Error('missing bindings for child Pino');
      }
      childOptions = childOptions || {};
      if (serialize && bindings.serializers) {
        childOptions.serializers = bindings.serializers;
      }
      var childOptionsSerializers = childOptions.serializers;
      if (serialize && childOptionsSerializers) {
        var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
        var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
        delete bindings.serializers;
        applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize);
      }
      function Child(parent) {
        this._childLevel = (parent._childLevel | 0) + 1;

        // make sure bindings are available in the `set` function
        this.bindings = bindings;
        if (childSerializers) {
          this.serializers = childSerializers;
          this._serialize = childSerialize;
        }
        if (transmit) {
          this._logEvent = createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
      }
      Child.prototype = this;
      var newLogger = new Child(this);

      // must happen before the level is assigned
      appendChildLogger(this, newLogger);
      newLogger.child = function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return child.call.apply(child, [this, setOpts].concat(args));
      };
      // required to actually initialize the logger functions for any given child
      newLogger.level = childOptions.level || this.level; // allow level to be set by childOptions
      setOpts.onChild(newLogger);
      return newLogger;
    }
    return logger;
  }
  function getLevels(opts) {
    var customLevels = opts.customLevels || {};
    var values = Object.assign({}, pino.levels.values, customLevels);
    var labels = Object.assign({}, pino.levels.labels, invertObject(customLevels));
    return {
      values: values,
      labels: labels
    };
  }
  function invertObject(obj) {
    var inverted = {};
    Object.keys(obj).forEach(function (key) {
      inverted[obj[key]] = key;
    });
    return inverted;
  }
  pino.levels = {
    values: {
      fatal: 60,
      error: 50,
      warn: 40,
      info: 30,
      debug: 20,
      trace: 10
    },
    labels: {
      10: 'trace',
      20: 'debug',
      30: 'info',
      40: 'warn',
      50: 'error',
      60: 'fatal'
    }
  };
  pino.stdSerializers = stdSerializers;
  pino.stdTimeFunctions = Object.assign({}, {
    nullTime: nullTime,
    epochTime: epochTime,
    unixTime: unixTime,
    isoTime: isoTime
  });
  function getBindingChain(logger) {
    var bindings = [];
    if (logger.bindings) {
      bindings.push(logger.bindings);
    }

    // traverse up the tree to get all bindings
    var hierarchy = logger[hierarchySymbol];
    while (hierarchy.parent) {
      hierarchy = hierarchy.parent;
      if (hierarchy.logger.bindings) {
        bindings.push(hierarchy.logger.bindings);
      }
    }
    return bindings.reverse();
  }
  function set(self, opts, rootLogger, level) {
    // override the current log functions with either `noop` or the base log function
    Object.defineProperty(self, level, {
      value: levelToValue(self.level, rootLogger) > levelToValue(level, rootLogger) ? noop : rootLogger[baseLogFunctionSymbol][level],
      writable: true,
      enumerable: true,
      configurable: true
    });
    if (self[level] === noop) {
      if (!opts.transmit) return;
      var transmitLevel = opts.transmit.level || self.level;
      var transmitValue = levelToValue(transmitLevel, rootLogger);
      var methodValue = levelToValue(level, rootLogger);
      if (methodValue < transmitValue) return;
    }

    // make sure the log format is correct
    self[level] = createWrap(self, opts, rootLogger, level);

    // prepend bindings if it is not the root logger
    var bindings = getBindingChain(self);
    if (bindings.length === 0) {
      // early exit in case for rootLogger
      return;
    }
    self[level] = prependBindingsInArguments(bindings, self[level]);
  }
  function prependBindingsInArguments(bindings, logFunc) {
    return function () {
      return logFunc.apply(this, [].concat(_toConsumableArray(bindings), Array.prototype.slice.call(arguments)));
    };
  }
  function createWrap(self, opts, rootLogger, level) {
    return function (write) {
      return function LOG() {
        var ts = opts.timestamp();
        var args = new Array(arguments.length);
        var proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === _console ? _console : this;
        for (var i = 0; i < args.length; i++) args[i] = arguments[i];
        var argsIsSerialized = false;
        if (opts.serialize) {
          applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
          argsIsSerialized = true;
        }
        if (opts.asObject || opts.formatters) {
          write.call(proto, asObject(this, level, args, ts, opts));
        } else write.apply(proto, args);
        if (opts.transmit) {
          var transmitLevel = opts.transmit.level || self._level;
          var transmitValue = levelToValue(transmitLevel, rootLogger);
          var methodValue = levelToValue(level, rootLogger);
          if (methodValue < transmitValue) return;
          transmit(this, {
            ts: ts,
            methodLevel: level,
            methodValue: methodValue,
            transmitLevel: transmitLevel,
            transmitValue: rootLogger.levels.values[opts.transmit.level || self._level],
            send: opts.transmit.send,
            val: levelToValue(self._level, rootLogger)
          }, args, argsIsSerialized);
        }
      };
    }(self[baseLogFunctionSymbol][level]);
  }
  function asObject(logger, level, args, ts, opts) {
    var _ref = opts.formatters || {},
      levelFormatter = _ref.level,
      _ref$log = _ref.log,
      logObjectFormatter = _ref$log === void 0 ? function (obj) {
        return obj;
      } : _ref$log;
    var argsCloned = args.slice();
    var msg = argsCloned[0];
    var logObject = {};
    if (ts) {
      logObject.time = ts;
    }
    if (levelFormatter) {
      var formattedLevel = levelFormatter(level, logger.levels.values[level]);
      Object.assign(logObject, formattedLevel);
    } else {
      logObject.level = logger.levels.values[level];
    }
    var lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && _typeof(msg) === 'object') {
      while (lvl-- && _typeof(argsCloned[0]) === 'object') {
        Object.assign(logObject, argsCloned.shift());
      }
      msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned);
    if (msg !== undefined) logObject[opts.messageKey] = msg;
    var formattedLogObject = logObjectFormatter(logObject);
    return formattedLogObject;
  }
  function applySerializers(args, serialize, serializers, stdErrSerialize) {
    for (var i in args) {
      if (stdErrSerialize && args[i] instanceof Error) {
        args[i] = pino.stdSerializers.err(args[i]);
      } else if (_typeof(args[i]) === 'object' && !Array.isArray(args[i]) && serialize) {
        for (var k in args[i]) {
          if (serialize.indexOf(k) > -1 && k in serializers) {
            args[i][k] = serializers[k](args[i][k]);
          }
        }
      }
    }
  }
  function transmit(logger, opts, args) {
    var argsIsSerialized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var send = opts.send;
    var ts = opts.ts;
    var methodLevel = opts.methodLevel;
    var methodValue = opts.methodValue;
    var val = opts.val;
    var bindings = logger._logEvent.bindings;
    if (!argsIsSerialized) {
      applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    }
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function (arg) {
      // bindings can only be objects, so reference equality check via indexOf is fine
      return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = createLogEventShape(bindings);
  }
  function createLogEventShape(bindings) {
    return {
      ts: 0,
      messages: [],
      bindings: bindings || [],
      level: {
        label: '',
        value: 0
      }
    };
  }
  function asErrValue(err) {
    var obj = {
      type: err.constructor.name,
      msg: err.message,
      stack: err.stack
    };
    for (var key in err) {
      if (obj[key] === undefined) {
        obj[key] = err[key];
      }
    }
    return obj;
  }
  function getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') {
      return opts.timestamp;
    }
    if (opts.timestamp === false) {
      return nullTime;
    }
    return epochTime;
  }
  function mock() {
    return {};
  }
  function passthrough(a) {
    return a;
  }
  function noop() {}
  function nullTime() {
    return false;
  }
  function epochTime() {
    return Date.now();
  }
  function unixTime() {
    return Math.round(Date.now() / 1000.0);
  }
  function isoTime() {
    return new Date(Date.now()).toISOString();
  } // using Date.now() for testability

  /* eslint-disable */
  /* istanbul ignore next */
  function pfGlobalThisOrFallback() {
    function defd(o) {
      return typeof o !== 'undefined' && o;
    }
    try {
      if (typeof globalThis !== 'undefined') return globalThis;
      Object.defineProperty(Object.prototype, 'globalThis', {
        get: function get() {
          delete Object.prototype.globalThis;
          return this.globalThis = this;
        },
        configurable: true
      });
      return globalThis;
    } catch (e) {
      return defd(self) || defd(window) || defd(this) || {};
    }
  }
  /* eslint-enable */

  browser.exports["default"] = pino;
  browser.exports.pino = pino;
  return browser.exports;
}

var browserExports = requireBrowser();
var pino = /*@__PURE__*/getDefaultExportFromCjs(browserExports);

/*!
 * dashify <https://github.com/jonschlinkert/dashify>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var dashify$1;
var hasRequiredDashify;
function requireDashify() {
  if (hasRequiredDashify) return dashify$1;
  hasRequiredDashify = 1;
  dashify$1 = function dashify(str, options) {
    if (typeof str !== 'string') throw new TypeError('expected a string');
    return str.trim().replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\W/g, function (m) {
      return /[À-ž]/.test(m) ? m : '-';
    }).replace(/^-+|-+$/g, '').replace(/-{2,}/g, function (m) {
      return options && options.condense ? '-' : m;
    }).toLowerCase();
  };
  return dashify$1;
}

var dashifyExports = requireDashify();
var dashify = /*@__PURE__*/getDefaultExportFromCjs(dashifyExports);

var pretty = {};

var isError = function isError(obj) {
  return Object.prototype.toString.call(obj) === '[object Error]';
};
var wrapMethod = function wrapMethod(target, member) {
  return function (key, message, details) {
    target[member](_objectSpread2({
      key: dashify(key, {
        condense: true
      }).toUpperCase()
    }, isError(details) ? {
      err: details
    } : details), message);
  };
};
function generateLogger(logLevel, additionalOptions) {
  var _process$env;
  var level = logLevel || typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.LOG_LEVEL) || typeof window !== 'undefined' && window.__ENV__ != null && window.__ENV__.LOG_LEVEL || 'info';
  var pinoConfiguration = _objectSpread2({
    level: level,
    messageKey: 'message',
    browser: {
      asObject: true
    }
  }, additionalOptions);
  var stream = typeof pretty === 'function' ? pretty({
    colorize: true
  }) : undefined;
  var pinoLogger = process.env.NODE_ENV === 'development' ? pino(_objectSpread2({}, pinoConfiguration), stream) : pino(pinoConfiguration);
  var logger = {
    trace: wrapMethod(pinoLogger, 'trace'),
    debug: wrapMethod(pinoLogger, 'debug'),
    info: wrapMethod(pinoLogger, 'info'),
    warn: wrapMethod(pinoLogger, 'warn'),
    error: wrapMethod(pinoLogger, 'error'),
    fatal: wrapMethod(pinoLogger, 'fatal')
  };
  return logger;
}

exports.generateLogger = generateLogger;
